export const MEMS_URL = "http://localhost:3000/mems";
export const UPLOAD_URL = "http://localhost:3001/upload";

